// const ProductList = ({ products }) => {
//   // Fonction pour mélanger un tableau
//   const shuffleArray = (array) => {
//     let shuffledArray = [...array];
//     for (let i = shuffledArray.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
//     }
//     return shuffledArray;
//   };

//   // Mélange les produits et sélectionne les 5 premiers
//   const shuffledProducts = shuffleArray(products);
//   const selectedProducts = shuffledProducts.slice(0, 8);

//   return (
//     <div className="product-lists grid bg-whitesmoke my-3">
//       {selectedProducts.map((product) => {
//         let discountedPrice =
//           product.price - product.price * (product.discountPercentage / 100);

//         return (
//           <Product key={product.id} product={{ ...product, discountedPrice }} />
//         );
//       })}
//     </div>
//   );
// };

import React from "react";
import "./ProductList.scss";
import Product from "../Product/Product";

const ProductList = ({ products }) => {
  // Sélectionne les 8 premiers produits sans mélange
  const selectedProducts = products.slice(0, 8);

  return (
    <div className="product-lists grid bg-whitesmoke my-3">
      {selectedProducts.map((product) => {
        let discountedPrice =
          product.price - product.price * (product.discountPercentage / 100);

        return (
          <Product key={product.id} product={{ ...product, discountedPrice }} />
        );
      })}
    </div>
  );
};

export default ProductList;


// import React from "react";
// import "./ProductList.scss";
// import Product from "../Product/Product";

// const ProductList = ({ products }) => {
//   // Sélectionne les 8 premiers produits sans mélange
//   const selectedProducts = products.slice(0, 8);

//   return (
//     <div className="product-lists grid bg-whitesmoke my-3">
//       {/* {selectedProducts.length > 0 ? (
//         selectedProducts.map((product) => (
//           <Product key={product.id} product={product} />
//         ))
//       ) : (
//         <div className="no-products">Aucun produit disponible</div>
//       )} */}
//     </div>
//   );
// };

// export default ProductList;

